import ShieldSvg from '@assets/images/svg/shield.svg';
import React from 'react';
import { View } from 'react-native';

export interface ShieldIconProps {
    size?: number;
    color?: string;
}

export function ShieldIcon({ size = 24, color = '#333333' }: ShieldIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <ShieldSvg width={size} height={size} color={color} />
        </View>
    );
}

export default ShieldIcon;

